import { Component, Inject, Input, Optional } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "@shared/services/user.service";
import { finalize, first } from "rxjs";

@Component({
  selector: "app-resend-verify",
  templateUrl: "./resend-verify.component.html",
  styleUrls: ["./resend-verify.component.scss"],
})
export class ResendVerifyComponent {
  @Input() isModal = false;

  public emailForm = this.fb.nonNullable.group({
    email: [
      "",
      [
        Validators.required,
        Validators.email,
        Validators.pattern(/^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/),
      ],
    ],
  });

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ResendVerifyComponent>,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private userService: UserService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { isModal: boolean }
  ) {
    if (data) {
      this.isModal = data.isModal;
    }
  }

  /**
   * Submits email to resend verification link
   */
  public onSubmit(): void {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }
    this.emailForm.disable();
    this.userService
      .resendVerify(this.emailForm.controls.email.value)
      .pipe(
        first(),
        finalize(() => this.emailForm.enable())
      )
      .subscribe({
        next: () => {
          this.snackBar.open(`✅ ${this.translateService.instant("page.registration.resend.msg")}`, "OK", { duration: 5000 });
          this.dialogRef.close(false);
        },
        error: () => {
          this.snackBar.open(`❗ ${this.translateService.instant("common.error")}`, "OK", {
            duration: 5000,
          });
        },
      });
  }

  /**
   * Closes the dialog without action
   */
  public close(): void {
    this.dialogRef.close(false);
  }
}
